import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Carriers from "./components/pages/Carriers";
import Contact from "./components/pages/Contact";
import Growth from "./components/pages/Growth";
import NewHome from "./components/pages/newHome";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<NewHome></NewHome>} />
        <Route path="/carriers" element={<Carriers></Carriers>}></Route>
        <Route path="/contact" element={<Contact></Contact>}></Route>
        <Route path="/leadership" element={<Growth></Growth>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
